import {
    ADD,
    DECREASE_QUANTITY,
    INCREASE_QUANTITY,
    IS_PRODUCT_PAGE,
} from "./actionTypes";
import initialState from "./initialState";

const nextProductId = (products) => {
    const maxId = products.reduce((maxId, product) => Math.max(product.id, maxId), -1);
    return maxId + 1;
};

const getQuantity = (isIncrease, products, prodcutId, quantityNeedToIncreaseOrDecrease) => {
    return products.map((product) =>
        product.id !== prodcutId ? product : { ...product, quantity: isIncrease ? product.quantity + quantityNeedToIncreaseOrDecrease : product.quantity - quantityNeedToIncreaseOrDecrease })
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD:
            const { name, category, imgURL, price, quantity } = action.payload;
            return {
                ...state,
                products: [
                    ...state.products
                    ,
                    {
                        id: nextProductId(state.products),
                        name,
                        category,
                        imgURL,
                        price,
                        quantity
                    }],
            };

        case INCREASE_QUANTITY:
            return {
                ...state,
                products: getQuantity(true, state.products, action.payload.productId, action.payload.quantity)

            }

        case DECREASE_QUANTITY:

            return {
                ...state,
                products: getQuantity(false, state.products, action.payload, 1)
            }

        case IS_PRODUCT_PAGE:
            return {
                ...state,
                isProductPage: action.payload
            };

        default:
            return state;
    }
};

export default reducer;
